export default [
  {
    name: 'add-row',
    icon: 'fa-grip-lines',
    method: 'addRow',
    classes: [],
    hoverable: false,
    menu: null,
  },
  {
    name: 'move',
    icon: 'fa-arrows-alt',
    method: null,
    classes: ['section-handle'],
    menu: null,
  },
  {
    name: 'delete',
    icon: 'fa-trash-alt',
    method: 'removeParent',
    classes: [],
    hoverable: false,
    menu: null,
  },
  {
    name: 'settings',
    icon: 'fa-cog',
    hoverable: true,
    method: 'openMenu',
    classes: [],
    menu: 'SectionMenu',
  }
]